
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best/[slug]",
      function () {
        return require("private-next-pages/best/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best/[slug]"])
      });
    }
  